import {
  FOG_100,
  MINT_100,
  MOSS_100,
  OwnUpSmallSubheadlineMedium,
  PINE_100,
  PropsWithTheme
} from '@rategravity/own-up-component-library';
import React from 'react';
import styled from 'styled-components';
import { displayNumber } from '../../common/utils';
import { useABComparison } from '../data/dataProvider';

const ResultPlate = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.up('md')} {
    width: 50%;
  }
  background-color: ${MOSS_100};
  border-radius: 8px;
  padding: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(3, 2)};
  row-gap: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(3)}px;
`;

const PlateRow = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${FOG_100};
`;
const ResultPlateTitle = styled(OwnUpSmallSubheadlineMedium)`
  padding-top: 0 !important;
`;

const VariantColor = styled.div<{ variant: 'A' | 'B' }>`
  width: 12px;
  height: 12px;
  border-radius: 2px;
  background-color: ${(props) => (props.variant === 'A' ? PINE_100 : MINT_100)};
  margin-right: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(1)}px;
  display: inline-block;
  margin-bottom: 2px;
`;

export const SummaryPlate = ({ variant }: { variant: 'A' | 'B' }) => {
  const { getMonthlyPayment, getTotalCost, getTotalTerm } = useABComparison();
  return (
    <ResultPlate>
      <PlateRow>
        <ResultPlateTitle varian="h4">
          <VariantColor variant={variant} />
          Option {variant}
        </ResultPlateTitle>
      </PlateRow>
      <PlateRow>
        <div>Loan term</div>
        <strong>{getTotalTerm()[variant]} years</strong>
      </PlateRow>
      <PlateRow>
        <div>Monthly payment</div>
        <strong>{displayNumber(getMonthlyPayment()[variant])}</strong>
      </PlateRow>
      <PlateRow>
        <div>Total cost</div>
        <strong>{displayNumber(getTotalCost()[variant])}</strong>
      </PlateRow>
    </ResultPlate>
  );
};
